import moment from "moment";
export const formatCurrency = (currency) => {
  let formetedCurrency = Number(currency)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, "$&,");
  // let splitArray = formetedCurrency.split(".");
  // if (splitArray.length > 1) {
  //   formetedCurrency = splitArray[0];
  // }
  return `${formetedCurrency}₮`;
};

export const formatPrice = (price, seperator = "$&,", symbol = "₮") => {
  let result;
  if (typeof param !== "number") {
    result = parseFloat(price);
    if (isNaN(result)) return;
  }

  result = Number(result)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, seperator);
  return `${result}${symbol}`;
};

export const formatCurrencyWithoutSymbol = (currency) => {
  let formetedCurrency = Number(currency)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, "$&,");
  let splitArray = formetedCurrency.split(".");
  if (splitArray.length > 1) {
    formetedCurrency = splitArray[0];
  }
  return `${formetedCurrency}`;
};

export const dateTimeISO = (date, time) => {
  return moment(date + "" + time, "YYYY-MM-DD HH:mm").toISOString();
};

export const getYmd = (datetime) => {
  return Date.parse(datetime) ? moment(datetime).format("YYYY/MM/DD") : "-";
};
export const getTime = (datetime) => {
  return datetime !== "" ? moment(datetime).format("HH:mm") : "-";
};
export const getDateTime = (datetime) => {
  return datetime ? moment(datetime).format("YYYY/MM/DD HH:mm:ss") : "-";
};
export const orderStatus = (status) => {
  let returnStatus = "";
  if (status === "created") {
    returnStatus = "Баталгаажаагүй";
  }
  return returnStatus;
};

export const invoiceStatus = (status) => {
  let returnStatus = "";
  if (status === "paid") {
    returnStatus = "Төлөгдсөн";
    return <p style={{ color: "#52C41A" }}>{returnStatus}</p>;
  }
  if (status === "pending") {
    returnStatus = "Хүлээгдэж байгаа";
    return <p style={{ color: "#4BBEDA" }}>{returnStatus}</p>;
  }
  if (status === "not_paid") {
    returnStatus = "Төлөөгүй";
    return <p style={{ color: "#FFAA00" }}>{returnStatus}</p>;
  }
  return returnStatus;
};
export const addressStyleProps = {
  rowGutter: [16, 0],
  columnSpans: [8, 8, 8],
};
// export const orderStatusConvert = (_enum, _enumDictionary, _currentStatus) => {
//   let returnStatus = "";
//   if (
//     _enum !== undefined &&
//     _enumDictionary !== undefined &&
//     _currentStatus !== undefined
//   ) {
//     returnStatus = _enum
//       .filter((type) => type === _currentStatus)
//       .map((value) => <h3 key={value}>{_enumDictionary[value]}</h3>);
//   }
//   return returnStatus;
// };

export const orderStatusConvert = (_enum, _enumDictionary, _currentStatus) => {
  let returnStatus = _currentStatus;
  if (_enum?.length && _enumDictionary && _currentStatus) {
    if (
      _enum.includes(_currentStatus) &&
      Object.keys(_enumDictionary).includes(_currentStatus)
    ) {
      returnStatus = _enumDictionary[_currentStatus];
      if (returnStatus === "Үүссэн") returnStatus = "Баталгаажаагүй";
    }
  }
  return returnStatus;
};

export const convertToMetr = (unit, value) => {
  const val = parseFloat(value);
  switch (unit) {
    case "mm":
      return val * 0.001;
    case "cm":
      return val * 0.01;
    default:
      return val;
  }
};

export const convertToCm = (unit, value) => {
  const val = parseFloat(value);
  switch (unit) {
    case "m":
      return val * 100;
    case "mm":
      return val * 0.1;
    case "cm":
      return val;
    default:
      return val;
  }
};

export const convertToKg = (unit, value) => {
  const val = parseFloat(value);
  switch (unit) {
    case "g":
      return val * 0.001;

    default:
      return val;
  }
};

export const convertToGramm = (unit, value) => {
  const val = parseFloat(value);
  switch (unit) {
    case "kg":
      return val;
    case "g":
      return val;

    default:
      return val;
  }
};

export const getBaseSku = (productSku = "") => {
  let tmpArray = productSku.split("-");
  if (tmpArray.length > 3) {
    tmpArray.splice(3, tmpArray.length - 3);
    let baseSku = tmpArray.join("-");
    return baseSku;
  }
  return productSku;
};

export const convertVVolumeToVolume = (vVolume = 0) => {
  // 1 vVolume = 1000 cm3
  const cm3 = vVolume * 1000;

  // //1cm3 = 0.000001 m3
  return cm3 * 0.000001;
};

export const convertM3toCm3 = (m3 = 0) => {
  return m3 * 1000000;
};

export const convertKgToGramm = (kg = 0) => {
  return kg * 1000;
};

export const formatVolume = (volume) => {
  let v = Number(volume).toFixed(6);
  return parseFloat(v);
};

/**
 * Жинг харуулах хэлбэрт оруулна.
 *
 * Өмнө нь `.toFixed(2)` байсан тул 0.002 кг гэх мэт жижиг жин ЧИМЭЭГҮЙ 0 болж,
 * захиалгын дэлгэрэнгүйд бодит утга алга болдог байв. `formatVolume`-тай ижил
 * 6 орны нарийвчлал авч, илүү тэгийг `parseFloat` хасна.
 */
export const formatKg = (weight) => {
  let v = Number(weight).toFixed(6);
  return parseFloat(v);
};

export const convertProductWeight = (gramm, toUnit) => {
  switch (toUnit) {
    case "kg":
      return gramm;

    default:
      return gramm;
  }
};

export const convertProductVolume = (cm3, toUnit) => {
  switch (toUnit) {
    case "mm":
      return parseFloat((cm3 * 1000)?.toFixed(3));
    case "m":
      return parseFloat((cm3 / 1000000)?.toFixed(3));

    default:
      return parseFloat(cm3?.toFixed(3)) || "-";
  }
};

export const convertProductSize = (cm, toUnit) => {
  switch (toUnit) {
    case "mm":
      return parseFloat((cm * 10)?.toFixed(2));
    case "m":
      return parseFloat((cm / 100)?.toFixed(3));

    default:
      return parseFloat(cm?.toFixed(2)) || "-";
  }
};
